import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-06ebff82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "software-manage-wrap" }
const _hoisted_2 = {
  class: "cm-ui-dialog-title",
  style: {"padding":"25px 15px"}
}
const _hoisted_3 = {
  class: "cm-ui-dialog-title",
  style: {"padding":"25px 15px"}
}

import { ref, reactive, onMounted, nextTick, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import dayjs from 'dayjs'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ServicePermissionService } from '@/services/service-permission.service'
import Card from '@/views/dashboard/_components/card/card.vue'
import StatisticsCards from './_components/statistics-cards.vue'
import SoftwareTypeDistributionChart from './_components/software-type-distribution-chart.vue'
import DepartmentInstallationChart from './_components/department-installation-chart.vue'
import SoftwareListTop10 from './_components/software-list-top10/software-list-top10.vue'
import TerminalListTop10 from './_components/terminal-list-top10/terminal-list-top10.vue'
import InstalledDetail from './_components/software-view/_components/installed-detail/installed-detail.vue'
import ClientInstalledDetail from './_components/client-view/_component/installed-detail/installed-detail.vue'
import { SoftwareManageService, SoftwareInfo } from './_components/software-view/software-view.service'
import { ClientViewService, ClientInfo } from './_components/client-view/client-view.service'
import { SoftManageService, softGroupTypeList } from './service'
import { TableViewMode } from '@/views/dashboard/_enum/table-view-mode'
import SoftwareModifyLog from '@/views/dashboard/notice-manage/software-modify-log/software-modify-log.vue'
import type { SoftwareManageStatCardKey } from './_components/software-statistics-cards.types'

const hasPermission = true

// 统计数据

export default /*#__PURE__*/_defineComponent({
  __name: 'software-manage',
  setup(__props) {

const { t } = useI18n()

const injector = useReflectiveInjector([SoftwareManageService, ClientViewService, SoftManageService])
const softwareService = injector.get(SoftwareManageService)
const clientService = injector.get(ClientViewService)
const softManageService = injector.get(SoftManageService)
const servicePermissionService = injector.get(ServicePermissionService)
const statistics = reactive({
  installedSoftwareCount: 0,
  todayChangedTerminals: 0
})

// 图表数据（含 group_id，与列表筛选一致）
const softwareTypeData = ref<Array<{ name: string; value: number; group_id?: number }>>([])
const departmentData = ref<Array<{ name: string; value: number; group_id?: number }>>([])

// 软件列表
const softwareDrawerVisible = ref(false)
const softwareGroupId = ref(-1)
/** 侧边栏软件列表：饼图传入的 soft_type，查看全部时不传 */
const softwareListDrawerSoftType = ref<number | undefined>(undefined)

// 终端列表
const clientDrawerVisible = ref(false)
const clientGroupId = ref(-1)
/** 侧边栏终端列表：饼图传入的部门 group_id，与「查看全部」时的 clientGroupId 对齐 */
const terminalListDrawerGroupId = ref(-1)

// 详情抽屉
const softwareDetailDrawerVisible = ref(false)
const currentSoftware = ref<SoftwareInfo>({} as SoftwareInfo)
const clientDetailDrawerVisible = ref(false)
const currentClient = ref<ClientInfo>({} as ClientInfo)

const softwareModifyLogDrawerVisible = ref(false)
const softwareModifyLogEmbedDefaults = ref<{ dateRange: [string, string] } | null>(null)
const softwareModifyLogDrawerTitle = ref('')

function handleSoftwareManageStatClick(key: SoftwareManageStatCardKey) {
  if (!hasPermission) return
  if (key === 'installedSoftware') {
    viewAllSoftware()
    return
  }
  if (key === 'todayChanged') {
    if (statistics.todayChangedTerminals <= 0) return
    const today: [string, string] = [
      dayjs().format('YYYY-MM-DD'),
      dayjs().format('YYYY-MM-DD')
    ]
    softwareModifyLogEmbedDefaults.value = { dateRange: today }
    softwareModifyLogDrawerTitle.value = `${t('menu.softwareModifyLog')} [${t('softwareManage.todayChangedTerminals')}]`
    softwareModifyLogDrawerVisible.value = true
  }
}

function viewAllSoftware() {
  if (!hasPermission) return
  softwareListDrawerSoftType.value = undefined
  softwareDrawerVisible.value = true
}

function viewAllClients() {
  if (!hasPermission) return
  terminalListDrawerGroupId.value = clientGroupId.value
  clientDrawerVisible.value = true
}

function onSoftwareTypeChartSliceClick (payload: { group_id?: number }) {
  if (payload.group_id === undefined || payload.group_id === null) return
  softwareListDrawerSoftType.value = payload.group_id
  softwareDrawerVisible.value = true
}

function onDepartmentChartSliceClick (payload: { group_id?: number }) {
  if (payload.group_id === undefined || payload.group_id === null) return
  terminalListDrawerGroupId.value = payload.group_id
  clientDrawerVisible.value = true
}

function showSoftwareDetailDrawer(item: SoftwareInfo) {
  currentSoftware.value = item
  softwareDetailDrawerVisible.value = true
}

function showClientDetailDrawer(item: ClientInfo) {
  currentClient.value = item
  clientDetailDrawerVisible.value = true
}

watch(softwareDrawerVisible, (visible) => {
  if (!visible) softwareListDrawerSoftType.value = undefined
})
watch(clientDrawerVisible, (visible) => {
  if (!visible) terminalListDrawerGroupId.value = clientGroupId.value
})

// 加载统计数据
async function loadStatistics() {
  try {
    const res = await softManageService.getSoftmgrSoftTypeStat()
    statistics.installedSoftwareCount = res.total || 0
    statistics.todayChangedTerminals = res.update_count || 0
  } catch (error) {
    console.error('加载统计数据失败:', error)
  }
}

// 加载图表数据
async function loadChartData() {
  try {
    // 加载软件类型分布TOP10
    const typeRes = await softManageService.getSoftmgrSoftTypeStat()
    softwareTypeData.value = (typeRes.list || []).map(item => ({
      name: item.group_name || t('softwareManage.unknownLabel'),
      value: item.Count || 0,
      group_id: item.group_id
    }))

    const groupRes = await softManageService.getSoftmgrSoftGroupTypeStat()
    departmentData.value = (groupRes.list || []).map((item: softGroupTypeList) => ({
      name: item.group_name || t('softwareManage.unknownLabel'),
      value: item.Count || 0,
      group_id: item.group_id ?? (item as { groupId?: number }).groupId
    }))
  } catch (error) {
    console.error('加载图表数据失败:', error)
    softwareTypeData.value = []
    departmentData.value = []
  }
}

onMounted(async () => {
  await nextTick()
  loadStatistics()
  loadChartData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(StatisticsCards, {
      "installed-software-count": statistics.installedSoftwareCount,
      "today-changed-terminals": statistics.todayChangedTerminals,
      onStatClick: handleSoftwareManageStatClick
    }, null, 8, ["installed-software-count", "today-changed-terminals"]),
    _createVNode(_component_el_row, {
      gutter: 16,
      class: "charts-row"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(SoftwareTypeDistributionChart, {
              data: softwareTypeData.value,
              onSliceClick: onSoftwareTypeChartSliceClick
            }, null, 8, ["data"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(DepartmentInstallationChart, {
              data: departmentData.value,
              onSliceClick: onDepartmentChartSliceClick
            }, null, 8, ["data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(Card, {
      size: "second",
      title: _ctx.$t('softwareManage.softwareListTop10')
    }, {
      titleAfter: _withCtx(() => [
        _createVNode(_component_el_tag, { size: "small" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(SoftwareListTop10, {
          "view-mode": _unref(TableViewMode).preview,
          "has-permission": hasPermission,
          "group-id": softwareGroupId.value,
          onViewAll: viewAllSoftware,
          onDetail: showSoftwareDetailDrawer
        }, null, 8, ["view-mode", "group-id"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(Card, {
      size: "second",
      class: "cm-ui-mt16",
      title: _ctx.$t('softwareManage.terminalListTop10')
    }, {
      titleAfter: _withCtx(() => [
        _createVNode(_component_el_tag, { size: "small" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(TerminalListTop10, {
          "view-mode": _unref(TableViewMode).preview,
          "has-permission": hasPermission,
          "group-id": clientGroupId.value,
          onViewAll: viewAllClients,
          onDetail: showClientDetailDrawer
        }, null, 8, ["view-mode", "group-id"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_el_drawer, {
      modelValue: softwareDrawerVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((softwareDrawerVisible).value = $event)),
      size: "80%",
      title: _ctx.$t('softwareManage.softwareList'),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(SoftwareListTop10, {
          "view-mode": _unref(TableViewMode).full,
          "has-permission": hasPermission,
          "group-id": softwareGroupId.value,
          "preset-soft-type": softwareListDrawerSoftType.value,
          style: {"padding":"10px 16px"},
          onDetail: showSoftwareDetailDrawer
        }, null, 8, ["view-mode", "group-id", "preset-soft-type"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_drawer, {
      modelValue: clientDrawerVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((clientDrawerVisible).value = $event)),
      size: "80%",
      title: _ctx.$t('softwareManage.terminalList'),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(TerminalListTop10, {
          "view-mode": _unref(TableViewMode).full,
          "has-permission": hasPermission,
          "group-id": terminalListDrawerGroupId.value,
          style: {"padding":"10px 16px"},
          onDetail: showClientDetailDrawer
        }, null, 8, ["view-mode", "group-id"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_drawer, {
      modelValue: softwareDetailDrawerVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((softwareDetailDrawerVisible).value = $event)),
      "destroy-on-close": "",
      size: "65%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('softwareManage.installedSoftwareTitle', { name: currentSoftware.value.name })), 1),
        _createVNode(InstalledDetail, {
          software: currentSoftware.value,
          "group-id": softwareGroupId.value,
          "has-permission": hasPermission
        }, null, 8, ["software", "group-id"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: softwareModifyLogDrawerVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((softwareModifyLogDrawerVisible).value = $event)),
      size: "80%",
      "destroy-on-close": "",
      "append-to-body": "",
      title: softwareModifyLogDrawerTitle.value
    }, {
      default: _withCtx(() => [
        (softwareModifyLogDrawerVisible.value && softwareModifyLogEmbedDefaults.value)
          ? (_openBlock(), _createBlock(SoftwareModifyLog, {
              key: 0,
              "embed-defaults": softwareModifyLogEmbedDefaults.value
            }, null, 8, ["embed-defaults"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_drawer, {
      modelValue: clientDetailDrawerVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((clientDetailDrawerVisible).value = $event)),
      size: 1100,
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('softwareManage.terminalInstalledTitle', { name: currentClient.value.computer_name })), 1),
        _createVNode(ClientInstalledDetail, {
          "group-id": clientGroupId.value,
          "client-info": currentClient.value,
          "has-permission": hasPermission
        }, null, 8, ["group-id", "client-info"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})